<template>
  <v-row justify="center">
    <v-dialog :value="value" @input="vaciar()" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">Realizar importación</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="!enviado && !enviadoObjetos">
            <v-form v-model="valid" id="valid" ref="form">
              <v-row>
                <v-col cols="12" sm="12">
                    <v-file-input label="Seleccionar archivo Excel" filled
                    v-model="fichero" id="fichero" prepend-icon="attach_file"
                    accept="application/vnd.ms-excel"
                    :rules="[fichero ? rules.validarFormatoExcel(fichero.type) : null]"
                    truncate-length="100"
                    ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
            <v-row>
              <v-col cols="12" sm="12">
                <v-btn @click="descargaPlantilla()" color="primary" class="mr-2" :disabled="loading">Plantilla</v-btn>
                <v-btn @click="descargaFormato()" color="primary" :disabled="loading">Formato</v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="enviadoObjetos">
            <v-tabs
              grow color="primary"
              background-color="transparent"
              class="transparentTabs"
            >
              <v-tab>
              Registros importados
              </v-tab>
              <v-tab>
              Registros no importados
              </v-tab>
              <v-tab-item>
                <v-container v-show="objetosOK">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="headersObjetoOK" :items="listaObjetosOK"
                        item-key="id" class="text-xs-center"
                        loading-text="Cargando datos...">
                        <template
                          v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="item in items" :key="item.id">
                              <td class="text-xs-center"><v-layout justify-center>{{ item.NOMBRE }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.SOCIEDAD }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.TIPO_DOCUMENTO }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.NÚMERO_DOCUMENTO }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.MÓVIL }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.TELÉFONO }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.EMAIL }}</v-layout></td>
                            </tr>
                          </tbody>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
              <v-tab-item>
                <v-container v-show="objetosKO">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="headersObjetoKO" :items="listaObjetosKO"
                        item-key="id" class="text-xs-center"
                        loading-text="Cargando datos...">
                        <template
                          v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="item in items" :key="item.id">
                              <td class="text-xs-center"><v-layout justify-center>{{ item.NOMBRE }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.SOCIEDAD }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.TIPO_DOCUMENTO }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.NÚMERO_DOCUMENTO }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.MÓVIL }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.TELÉFONO }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.EMAIL }}</v-layout></td>
                              <td class="text-xs-center"><v-layout justify-center>{{ item.MOTIVO }}</v-layout></td>
                            </tr>
                          </tbody>
                        </template>
                      </v-data-table>
                    </v-col>
                 </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="(enviado || enviadoObjetos) ? $emit('reload') : null; vaciar(); $emit('input');">Cerrar</v-btn>
            <v-btn color="primary" @click.native="enviar()" :disabled="loading" v-if="!enviado && !enviadoObjetos">Importar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/* import { mapActions } from 'vuex' */
import moment from 'moment'
import rulesMixin from '@/components/generic/rules.js'
import gestionMixin from '@/components/generic/importarGestion.js'

export default {
  mixins: [rulesMixin, gestionMixin],
  props: {
    value: Boolean,
    singleItem: Array,
    tipo: String
  },
  created(){
    this.seccion = this.tipo
    console.log('entro al created y veo la seccion', this.seccion);
  },
  methods: {
    formatDate (dateToFormat) {
      return moment(dateToFormat, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
  }
}
</script>

<style scoped>

</style>
